module.exports = __webpack_public_path__ + "static/media/538.a574db86.png";